import StartChatSource from '../../store/schema/StartChatSource';
import getSkypeApi from '../chatManager/getSkypeApi';
import setIsSkypeShown from '../../chatManager/setIsSkypeShown';

export default function startUcwaChat(sipUris: string[], subject: string, source: StartChatSource) {
    setIsSkypeShown(true);
    getSkypeApi().then(api => api.startConversation(sipUris));
}
